import AudioPlayer from 'components/AudioPlayer';

interface AudioProps extends Record<string, unknown> {
    url?: string | null;
}

const Audio = ({ url }: AudioProps) => <AudioPlayer url={url} />;

export default Audio;
